import { UserDto } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useEffect } from "react";

import { axios } from "@/client/libs/axios";
import { identifyAnalyticsUser } from "@/client/libs/analytics";
import { useAuthStore } from "@/client/stores/auth";

export const fetchUser = async () => {
  const response = await axios.get<UserDto, AxiosResponse<UserDto>>("/user/me");

  return response.data;
};

export const useUser = () => {
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    data: user,
  } = useQuery({
    queryKey: ["user"],
    queryFn: fetchUser,
    staleTime: 10_000,
    refetchOnMount: true,
  });

  useEffect(() => {
    setUser(user ?? null);
    if (user?.id) identifyAnalyticsUser(user.id, user.email);
  }, [user, setUser]);

  return { user: user, loading, error };
};
